import { Navigate } from 'react-router-dom';
import Main from '../components/layout/Main';
export const PrivateRoute = ({ children }) => {
  return localStorage.getItem('token') ? <Main>{children}</Main> : <Navigate to="/login" replace />;
};
